module.exports = __webpack_public_path__ + "assets/img/65p_525_1.97cd13e0.jpg";